import { render, staticRenderFns } from "./RatingWorker.vue?vue&type=template&id=537afca2&scoped=true"
import script from "./RatingWorker.vue?vue&type=script&lang=js"
export * from "./RatingWorker.vue?vue&type=script&lang=js"
import style0 from "./RatingWorker.vue?vue&type=style&index=0&id=537afca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537afca2",
  null
  
)

export default component.exports